import type { ComponentProps } from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'

export const PageWrapper = (props: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn(
			'flex h-[calc(100dvh-60px)] flex-col gap-4 pt-4',
			props.className,
		)}
	/>
)

export const ContentWrapper = (props: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('flex flex-1 flex-row overflow-hidden', props.className)}
	/>
)

export const FiltersWrapper = (props: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('flex flex-row items-start gap-4 px-4', props.className)}
	/>
)

export const ListWrapper = ({ ...props }: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn(
			'h-full w-full',
			'group-data-[map-visible="true"]:hidden group-data-[map-visible="true"]:md:block group-data-[map-visible="true"]:md:w-1/2 group-data-[map-visible="true"]:lg:w-2/3 group-data-[map-visible="true"]:xl:w-[945px]',
			props.className,
		)}
	/>
)

export const MapWrapper = ({ ...props }: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn(
			'relative flex flex-1 shrink-0 flex-col pt-[2px]',
			'hidden group-data-[map-visible="true"]:block',
			props.className,
		)}
	/>
)
